// Brand & contact constants for InfoPoint Albania (phone-first, no email).
export const BRAND = {
  name: 'InfoPoint Albania',
  tagline: 'Your Smart Guide',
  slogan: "Discover Albania's Hidden Gems",
  description: "Explore authentic destinations, local experiences, hotels, restaurants, nightlife, beaches, and unforgettable adventures across Albania and the Balkans.",
  domain: 'infopointalbania.al',
  legalName: 'InfoPoint Albania',
};

export const CONTACT = {
  phoneRaw: '355683666663',
  phoneE164: '+355683666663',
  phoneDisplay: '+355 68 366 6663',
  whatsapp: 'https://wa.me/355683666663',
  whatsappQuick: (text) => `https://wa.me/355683666663?text=${encodeURIComponent(text)}`,
  telLink: 'tel:+355683666663',
  address: {
    street: 'Rruga Murat Toptani',
    city: 'Tirana',
    country: 'Albania',
    postalCode: '1001',
  },
};

export const SOCIAL = {
  instagram: 'https://instagram.com/infopointalbania',
  facebook: 'https://facebook.com/infopointalbania',
  tiktok: 'https://tiktok.com/@infopointalbania',
};
